// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const getCarrierInfo = (state: ApplicationState) => {
    return state.store.pages.checkoutShipping.carrierInfo;
};
export const getSaveAddress = (state: ApplicationState) => {
    return state.store.pages.checkoutShipping.saveAddress;
};
